/**
 * 시드와 다른 상황을 만드는 handler 묶음. 주소에 `?scenario=이름` 을 붙이면 ./entry.ts 가
 * 기본 handler 위에 덮어씌운다 — 빈 목록·서버 오류 같은 화면을 시드를 고치지 않고 본다.
 *
 * ui-snapshots 브랜치의 캡처도 이 이름으로 상황을 고른다. 이름을 바꾸면 거기 screens.ts 도
 * 같이 고친다.
 */
import { HttpResponse, http, type RequestHandler } from "msw";
import { fail, latency } from "./http";

/** 앱 뼈대(로그인 사용자·사이트 정보)가 서야 오류 화면이 보인다. 이 둘은 오류에서 뺀다. */
const SHELL = ["/api/v1/me/", "/api/v1/site/"];

export const scenarios: Record<string, RequestHandler[]> = {
  "projects-empty": [
    http.get("/api/v1/projects/", async () => {
      await latency();
      return HttpResponse.json({ results: [] });
    }),
    http.get("/api/v1/projects/process/", async () => {
      await latency();
      return HttpResponse.json({ results: [] });
    }),
  ],

  "server-error": [
    http.get("/api/v1/*", async ({ request }) => {
      if (SHELL.includes(new URL(request.url).pathname)) return;
      await latency();
      return fail(500, "서버에 문제가 생겼습니다.");
    }),
  ],
};
